<template>
  <v-container>
    <v-layout row>
      <v-flex
        offset-3
      >
        <v-card-text>
          <v-container>
            <span v-if="foundDancer">
              <h2>Welcome {{ firstName }}!</h2>
              <p>Redirecting to your dashboard...</p>
            </span>
            <form
              v-else
              @submit.prevent="onLogIn"
            >
              <v-layout>
                <v-flex>
                  <v-text-field
                    id="email"
                    v-model="email"
                    name="email"
                    label="Email"
                    type="email"
                    required
                  />
                  <v-text-field
                    id="last4"
                    v-model="last4"
                    name="last4"
                    label="Last 4 Digits of Phone #"
                    type="number"
                    required
                  />
                </v-flex>
              </v-layout>
              <v-layout
                row
                pt-5
              >
                <v-flex>
                  <v-btn
                    class="primary"
                    :disabled="!formIsValid"
                    type="submit"
                  >
                    Look Up Reservation
                  </v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-container>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        email: '',
        last4: '',
        firstName: '',
        embed: false,
        foundDancer: false
      }
    },
    computed: {
      currentIABFDancer () {
        return this.$store.getters.currentIABFDancer
      },
      formIsValid () {
        return this.email !== '' && this.last4 !== ''
      }
    },
    created () {
      if (this.$route.query.embed) {
        this.embed = true
        this.$store.commit('setLayout', 'embed-layout')
      }
    },
    methods: {
      onLogIn () {
        if (!this.formIsValid) {
          return
        }
        const dancerData = {
          email: this.email,
          last4: this.last4
        }
        this.$store.dispatch('lookUpIABFDancer', dancerData).then(() => {
          if (this.currentIABFDancer && this.currentIABFDancer.id) {
            this.firstName = this.currentIABFDancer.firstName
            this.foundDancer = true
            const redirect = this.$route.query && this.$route.query.redirect
            const destination = redirect ? String(redirect) : '/'
            this.$router.push(destination)
          }
        })
      }
    }
  }
</script>
